module.exports = __webpack_public_path__ + "img/T04.dd829934.jpg";